.tabs {
  display: grid;
  align-content: start;
  gap: var(--space-3);
  min-width: 0;
}

/* The focused tab draws its own ring; the container would otherwise outline the whole panel. */
.tabs[data-focus-visible] {
  outline: none;
  box-shadow: none;
}

.tabList {
  display: flex;
  gap: var(--space-1);
  overflow-x: auto;
  border-bottom: var(--border-default) solid var(--color-border-subtle);
  padding-bottom: 0;
}

.tab {
  padding: var(--space-2) var(--space-4);
  border-radius: var(--radius-control) var(--radius-control) 0 0;
  color: var(--color-content-secondary);
  font: var(--type-compact);
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  outline: none;
}

.tab:hover {
  background: var(--color-bg-hover);
}

.tab[data-selected] {
  color: var(--color-content-primary);
  box-shadow: inset 0 calc(-1 * var(--border-strong)) 0 var(--color-border-strong);
}

.tab[data-focus-visible] {
  outline: var(--border-strong) solid var(--color-focus-ring);
  outline-offset: 2px;
  box-shadow: 0 0 0 2px var(--focus-ring-inner, var(--color-bg-surface));
}

.tabPanel {
  min-width: 0;
  outline: none;
}

.tabPanel[data-focus-visible] {
  outline: var(--border-strong) solid var(--color-focus-ring);
  outline-offset: 2px;
  box-shadow: 0 0 0 2px var(--focus-ring-inner, var(--color-bg-surface));
}
